<template>
  <div id="app">
  	<router-view v-wechat-title="$route.meta.title" />
  	<my-login></my-login>
  </div>
</template>

<script>
import login from '@/components/common/login'
export default {
  name: "app",
  components: {
    "my-login": login
  }
}
</script>

<style>
@font-face {
  font-family: "pingfang";
  src: url(../static/font/pingfang.ttf);
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "微软雅黑", "microsoft yahei", "microsoft sans serif";
  user-select:none;
}
/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
/*定义滚动条轨道 内阴影+圆角*/
/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  background-color: transparent;
}
::-webkit-scrollbar-track {
  background-color: transparent;
}
::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
}
::-webkit-scrollbar-thumb:hover {
  background-color: rgba(0, 0, 0, 0.3);
}

body {
  min-width: 1300px;
}
ul,
ol,
li {
  list-style: none;
}
img {
  max-width: 100%;
  border: none;
}
a {
  color: #333;
  text-decoration: none;
  transition: all 0.2s ease-out 0s;
}
a:hover {
  color: #333;
}

#app {
	height: auto;
  min-height: 100vh;
  position: relative;
}
</style>


// WEBPACK FOOTER //
// src/App.vue